import {
  formatErrorWithRequestId,
  getRequestErrorMessage,
  readApiErrorEnvelope,
} from '#/utils/requestError';

/** 報價 route 錯誤 envelope 用 `trace_id`；`readApiErrorEnvelope` 兩種都讀。 */
const QUOTATION_ERROR_MESSAGES = {
  RESOURCE_VERSION_CONFLICT: '報價單已被他人修改或已非草稿，請重新載入後再試',
  QUOTATION_CUSTOMER_INACTIVE: '客戶已停用，請改選啟用中的客戶',
  QUOTATION_PAYMENT_TERM_INACTIVE: '付款條件已停用，請改選或清空',
  QUOTATION_QTY_INVALID: '數量須大於 0，最多四位小數、16 位整數',
  QUOTATION_UNIT_PRICE_INVALID: '單價不可為負，最多四位小數、16 位整數',
  QUOTATION_SUB_LINE_NAME_REQUIRED: '子項目品名必填',
  QUOTATION_UPDATE_NOT_ALLOWED: '已發出的報價單只能修改內部備註',
  QUOTATION_ISSUE_LINES_REQUIRED: '發出前所有主項目都要填齊品名、數量、單位與單價',
  QUOTATION_VALID_UNTIL_INVALID: '有效截止日不可早於今天（台北時間）',
};

export function isQuotationVersionConflict(error) {
  const code = error?.response?.data?.code;
  return code === 'RESOURCE_VERSION_CONFLICT';
}

export function getQuotationApiErrorMessage(error, fallback = '操作失敗') {
  const envelope = readApiErrorEnvelope(error);
  const known = envelope?.code ? QUOTATION_ERROR_MESSAGES[envelope.code] : null;
  if (known && envelope.status < 500) {
    return formatErrorWithRequestId(envelope.message || known, envelope.requestId);
  }
  const message = getRequestErrorMessage(error, fallback);
  return formatErrorWithRequestId(message, envelope?.status >= 500 ? undefined : envelope?.requestId);
}
